import { AuthedAxiosRequests } from 'features/auth'

export const triggerInspectionEditPipeline = async (
  slug: string,
  dsApiUrl: string,
  axios: AuthedAxiosRequests,
  isFulcrum: boolean
) => {
  return await axios.post(
    `${dsApiUrl}/api/v1/pipelines/${slug}/inspection-config?is_fulcrum=${isFulcrum}`,
    undefined,
    { headers: { 'Content-Type': 'application/json' } }
  )
}
